/* src/components/pdf-page-quickscan/pdf-page-quickscan.component.scss */
app-pdf-page-quickscan {
  display: block;
}
/*# sourceMappingURL=pdf-page-quickscan.component-VQPTNY6Y.css.map */
